import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IDeviceStateControllerReturn } from "../../../../../../commonreact/main/services/devicestate/DeviceStateController";
import { EDeviceScreenWidth } from "../../../../../../commonreact/main/services/devicestate/DeviceStateEnums";
import AppCSSService from "../../../services/AppCSSService";

interface IProps {
  dsc: IDeviceStateControllerReturn;
}

export interface IPublicNavbarControllerReturn {
  //states
  isHidden: boolean;// setIHidden: Dispatch<SetStateAction<boolean>>;
  isSmallGUI: boolean, 
  menuIsOpen: boolean; setIsOpen: Dispatch<SetStateAction<boolean>>;
  textProps: string;
}

export const PublicNavbarController = (props: IProps): IPublicNavbarControllerReturn => {

  const [isHidden, setIHidden] = useState(false);
  const [menuIsOpen, setIsOpen] = useState(false);
  const [isSmallGUI, setIsSmallGUI] = useState(false);
  useEffect(() => {
    if (props.dsc.medium){
      setIsSmallGUI(true);
      return
    }
    setIsSmallGUI(false) 
  }, [props.dsc.medium])




  const [textProps, setTextProps] = useState<string>(AppCSSService.textDefault);
  useEffect(() => {
    switch (props.dsc.eDeviceScreenState)
    {
      case EDeviceScreenWidth.Small: setTextProps(AppCSSService.textDefault); return;
      case EDeviceScreenWidth.Medium: setTextProps(AppCSSService.textDefault + " inline-block mr-0 mt-0"); return;
      case EDeviceScreenWidth.Large: setTextProps(AppCSSService.textDefault + " inline-block mt-0"); return;
      case EDeviceScreenWidth.ExtraLarge: setTextProps(AppCSSService.textBig + " inline-block mt-0"); return;
      case EDeviceScreenWidth._null: setTextProps(AppCSSService.textDefault); return;
      default: setTextProps(AppCSSService.textBig + " inline-block mt-0"); return;
    }
  }, [props.dsc.eDeviceScreenState])


  //#region init
  useEffect(()=>{
    addSelfAsListener();
    return () => {
      removeSelfAsListener();
    }
  },[])
  //#endregion

  const addSelfAsListener = () => {
    window.addEventListener("scroll", handleScroll);
  }

  const removeSelfAsListener = () => {
    window.removeEventListener("scroll", handleScroll);
  }
  function handleScroll(e: Event): void {
    //console.log("Scroll event triggered. Current scroll position:", window.scrollY);
    if(window.scrollY<=150){
      setIHidden(false)
      return
    }
    setIHidden(true)
}
  // onWindowsScroll(event: Event) {
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  //   if (scrollTop <= 50) {
  //     // Execute your code here
  //   }


  return {
    isHidden,// setIHidden,
    isSmallGUI,
    menuIsOpen, setIsOpen,
    textProps
  }
}
